import React from 'react';
import { User, Mail, Phone } from 'lucide-react';
import { propertyOwnershipTypes } from '../../lib/constants';
import type { StepProps } from './types';

export default function ContactDetailsStep({ formData, handleInputChange }: StepProps) {
  return (
    <div className="space-y-6">
      <div className="space-y-4 mb-8">
        {propertyOwnershipTypes.map(({ value, label }) => (
          <label key={value} className="flex items-center space-x-3">
            <input
              type="radio"
              name="proprietaire"
              value={value}
              checked={formData.proprietaire === value}
              onChange={handleInputChange}
              className="w-5 h-5 rounded-full border-gray-300 
                checked:bg-gradient-to-r checked:from-[#2A4365] checked:via-[#4A5568] checked:to-[#C4A052]
                focus:ring-[#2A4365] focus:ring-offset-2 transition-all duration-300"
            />
            <span className="text-sm text-gray-700">{label}</span>
          </label>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Civilité*
          </label>
          <div className="flex space-x-4">
            <label className="flex items-center">
              <input
                type="radio"
                name="civilite"
                value="M"
                checked={formData.civilite === 'M'}
                onChange={handleInputChange}
                className="w-5 h-5 rounded-full border-gray-300 
                  checked:bg-gradient-to-r checked:from-[#2A4365] checked:via-[#4A5568] checked:to-[#C4A052]
                  focus:ring-[#2A4365] focus:ring-offset-2 transition-all duration-300"
              />
              <span className="ml-2">M.</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="civilite"
                value="Mme"
                checked={formData.civilite === 'Mme'}
                onChange={handleInputChange}
                className="w-5 h-5 rounded-full border-gray-300 
                  checked:bg-gradient-to-r checked:from-[#2A4365] checked:via-[#4A5568] checked:to-[#C4A052]
                  focus:ring-[#2A4365] focus:ring-offset-2 transition-all duration-300"
              />
              <span className="ml-2">Mme</span>
            </label>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prénom
          </label>
          <div className="relative">
            <User className="absolute left-3 top-1/2  transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="text"
              name="prenom"
              value={formData.prenom}
              onChange={handleInputChange}
              className="pl-10 w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nom
          </label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="text"
              name="nom"
              value={formData.nom}
              onChange={handleInputChange}
              className="pl-10 w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="pl-10 w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Téléphone
          </label>
          <div className="relative">
            <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
            <input
              type="tel"
              name="telephone"
              value={formData.telephone}
              onChange={handleInputChange}
              className="pl-10 w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
              required
            />
          </div>
        </div>
      </div>
    </div>
  );
}